import { useEffect, type ReactElement } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { TipoInterviniente } from '@/components/Interviniente';
import { type SujetoForm } from '@/components/Interviniente/config';
import DatosJuridica from '@/components/Interviniente/form/DatosJuridica';
import DatosPersona from '@/components/Interviniente/form/DatosPersona';
import ModalSubsanacionInterviniente from '@/components/ModalSubsanacionInterviniente';
import RepresentanteListado from '@/components/RepresentanteListado';

import { TIPO_PERSONA } from '@/constants/tramite.constants';
import { mapSujetoDBToForm } from '@/helpers/formSujeto';
import { type ISubsanacionSujeto } from '@/interfaces/model/don.interface';

const SujetoSection = ({
	data,
	isShowSubsanacion,
	onCloseSubsanacion,
	onSubmitSubsanacion,
	className,
}: {
	readonly data: ISubsanacionSujeto;
	readonly isShowSubsanacion: boolean;
	readonly className?: string;
	readonly onCloseSubsanacion: () => void;
	readonly onSubmitSubsanacion: () => void;
}): ReactElement => {
	const { sujetoErroneo, tramite, tipo, id } = data;

	const methods = useForm<SujetoForm>({
		mode: 'onChange',
	});

	const { reset, watch } = methods;

	const getData = async () => {
		const sujetoMapped = mapSujetoDBToForm(sujetoErroneo);
		reset(sujetoMapped);
	};

	const idTipoPersona = watch('idTipoPersona');

	useEffect(() => {
		getData();
	}, []);

	return (
		<div className={className}>
			<FormProvider {...methods}>
				<h4 className="c-pnp-heading-h4">Datos del sujeto a subsanar</h4>
				<TipoInterviniente isDisplay className="[ p-detail-parties ] [ u-mt-16 ]" />
				{Number(idTipoPersona) === TIPO_PERSONA.JURIDICA ? (
					<DatosJuridica isDisplay className="[ p-detail-parties ] [ u-mt-24 ] "/>
				) : (
					<DatosPersona isDisplay className="[ p-detail-parties ] [ u-mt-24 ] " />
				)}
				{Number(idTipoPersona) === TIPO_PERSONA.JURIDICA && (
					<div className="u-mt-40">
						<h4 className="c-pnp-heading-h4">Representantes</h4>
						<RepresentanteListado isDisplay idPersonaJuridica={sujetoErroneo.id} className="u-mt-16" />
					</div>
				)}
			</FormProvider>
			<ModalSubsanacionInterviniente
				data={{
					idTramite: tramite.id,
					idTipo: tipo.id,
					id,
				}}
				isOpen={isShowSubsanacion}
				onClose={onCloseSubsanacion}
				onSubmit={onSubmitSubsanacion}
			/>
		</div>
	);
};

export default SujetoSection;
